module.exports = __webpack_public_path__ + "img/益视说明书_21.acfb9e8a.png";